/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Google_ConnectInputs */

const en_settings_google_connect = /** @type {(inputs: Settings_Google_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect Google account`)
};

const he_settings_google_connect = /** @type {(inputs: Settings_Google_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`חיבור חשבון גוגל`)
};

/**
* | output |
* | --- |
* | "Connect Google account" |
*
* @param {Settings_Google_ConnectInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const settings_google_connect = /** @type {((inputs?: Settings_Google_ConnectInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Google_ConnectInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_google_connect(inputs)
	return he_settings_google_connect(inputs)
});